import { isEqual } from 'lodash'
import { useMemo, useRef } from 'react'

export const useMemoWithResultCheck = <T extends (...args: any[]) => any>(factory: T, deps: React.DependencyList) => {
  const ref = useRef<ReturnType<T>>()

  return useMemo(
    () => {
      const result = factory()

      if (isEqual(result, ref.current)) {
        return ref.current
      }

      ref.current = result

      return result
    },
    // It is OK not to have factor in the deps array because we only want to
    // re-run the factory when deps change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps,
  ) as ReturnType<T>
}
